import React from 'react';
import PropTypes from 'prop-types';

import DisconnectDialog from "./DisconnectDialog";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import MuiButton from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

DisconnectDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function Header({color, values, isConnected, disconnectFunction}) {
	const [dialogOpen, setDialogOpen] = React.useState(false);
	
	const handleClose = (value) => {
    	setDialogOpen(false);
  	};


	let texts = [];
	// if(props !== null && props !== undefined){	
		texts = values.map((value, index)=> {
			const isLastItem = (index === values.length - 1);
      		const comma = isLastItem ? '' : ', ';
			return (<Typography key = {index} variant="h6" sx={{marginRight:"5px", textShadow: "0px 0px 5px black"}}>{value+comma}</Typography>)
		})
	// }

	const handleClickOpen = () => {
    	setDialogOpen(true);
  	};

	return (
	<Box sx={{marginBottom:"30px"}}>
	  <AppBar position="static">
	    <Toolbar sx={{ bgcolor: color}}>
	    {texts}
	    <Box sx={{ flexGrow: 1 }} />
        {isConnected && <MuiButton 
			// disabled = {disabled}
			// type="submit"
			onClick = {handleClickOpen}
			// value={value}
			size="large" 
			variant="contained">
			{"Disconnect"}
		</MuiButton>}
	    </Toolbar>
	    <DisconnectDialog
	        open={dialogOpen}
    	    onClose={handleClose}
    	    disconnectFunction={disconnectFunction}
	    />
	  </AppBar>
	</Box>
	);
}